import { actionCopyDa } from "./actionCopy";

export const inviteCopyDa = {
    reviewSetup: "Gennemgå opsætning",
    organisationAndContact: "Organisation og kontakt",
    addPatient: "Tilføj patient",
    inviteByEmail: "Inviter via e-mail",
    shareQrCode: "Del link / QR-kode",
    inviteSent: "Invitation sendt",
    inviteSentTo: (email) => `Invitation sendt til ${email}`,
    loading: actionCopyDa.loading,
    justAMoment: "Et øjeblik...",
    patientEmailWillReceiveInstructions: (email) =>
        `${email} modtager en e-mail med instruktioner til at komme i gang.`,
    patientPhoneWillReceiveInstructions: (phone) => `${phone} modtager en sms med instruktioner til at komme i gang.`,
    patientWillReceiveInstructions: "Din patient modtager en e-mail med instruktioner til at komme i gang.",
    emailAndMobileHint: "Begge dele, hvis du kan.",
    emailOrPhoneRequired: "(eller telefon påkrævet)",
    mobileOrEmailRequired: "(eller e-mail påkrævet)",
    diariesAddedInLast7Days: (count) => `I de seneste 7 dage har du tilføjet ${count} dagbøger til Patient Watch.`,
    goToDiary: "Gå til dagbog",
    inviteAnotherPatient: "Inviter en anden patient",
    whatWasInjected: "Hvad blev injiceret",
    clinicians: "Klinikere",
    referringClinician: "Henvisende kliniker",
    injectingClinician: "Injicerende kliniker",
    operatingSurgeon: "Opererende kirurg",
    therapist: "Terapeut",
    injectionMethod: "Injektionsmetode",
    questionnaires: "Spørgeskemaer",
    clinicContact: "Klinikkontakt",
    surgeryDetails: "Operationsdetaljer",
    injectionDetails: "Injektionsdetaljer",
    treatmentDetails: "Behandlingsdetaljer",
    consultationDetails: "Konsultationsdetaljer",
    consultationName: "Konsultationsnavn",
    description: "Beskrivelse",
    clinician: "Kliniker",
    consultingClinician: "Konsulterende kliniker",
    consultingClinicianDescription: "Klinikeren, der gennemførte konsultationen",
    productDetails: "Produktdetaljer",
    providingClinician: "Uddelende kliniker",
    providingClinicianDescription: "Klinikeren, der ordinerede, udleverede eller opsatte produktet",
    usageInstructions: "Brugsvejledning",
    editInjectionDetails: "Rediger injektionsdetaljer",
    editInjectionClinicians: "Rediger injektionsklinikere",
    editSurgeryDetails: "Rediger operationsdetaljer",
    editSurgeryClinicians: "Rediger operationsklinikere",
    editShockwaveDetails: "Rediger stødbolgedetaljer",
    editShockwaveClinicians: "Rediger stødbolgeklinikere",
    editConsultationDetails: "Rediger konsultationsdetaljer",
    editConsultingClinician: "Rediger konsulterende kliniker",
    editProductDetails: "Rediger produktdetaljer",
    editProvidingClinician: "Rediger uddelende kliniker",
    editClinicContact: "Rediger klinikkontakt",
    notSet: "Ikke angivet",
    selected: "Valgt",
    unknownForm: "Ukendt formular",
    unknownSchedule: "Ukendt tidsplan",
    noSide: "Ingen side",
    noOptionSelected: "Ingen mulighed valgt",
    noSubstanceSelected: "Intet stof valgt",
    noSiteSelected: "Ingen side eller område valgt",
    email: "E-mail",
    enterEmail: "Angiv e-mail",
    titleOptional: "Titel (valgfrit)",
    firstNameOptional: "Fornavn (valgfrit)",
    lastNameOptional: "Efternavn (valgfrit)",
    mobileNumber: "Mobilnummer",
    firstNamePlaceholder: "f.eks. Sherlock",
    lastNamePlaceholder: "f.eks. Holmes",
    selectPlaceholder: "Vælg",
    sendInvite: "Send invitation",
    sendingInvite: "Sender invitation…",
    inviteSentToast: "Invitation sendt",
    existingPatient: "Eksisterende patient",
    existingPatientAddDiary: "Vi tilføjer denne dagbog til deres eksisterende konto.",
    existingUser: "Eksisterende bruger",
    existingUserAddToOrganisation: "Vi tilføjer dem til denne organisation i stedet for at oprette en ny konto.",
    existingSecretary: "Eksisterende sekretær",
    existingSecretaryAddAsYours: "Vi tilføjer dem som din sekretær for denne organisation.",
    diaryQuotaBlockedTitle: "Dagbogsgrænse nået",
    diaryQuotaUsage: (used: number, limit: number) =>
        `Du har brugt ${used} af ${limit} dagbøger i denne faktureringsperiode.`,
    diaryQuotaBlockedDescription: "Opgrader din plan for at invitere flere patienter med dagbog.",
    diaryQuotaUpgradeCta: "Vælg en plan",
    diaryQuotaOwnerUnresolved:
        "Vi kunne ikke afgøre, hvilken klinikers dagbogskvote der gælder. Kæd denne sekretær til én kliniker, eller inviter mens du er logget ind som den kliniker.",
    noTemplateSelected: "Ingen skabelon valgt. Opret venligst",
    createTemplate: "en skabelon",
    createTemplateFirst: "først.",
    organisation: "Organisation",
    hospitalNumberOptional: "Hospitalsnummer (valgfrit)",
    enterNhsHospitalNumber: "Angiv NHS-hospitalsnummer",
    hospitalNumberDescription: "Hjælper med at matche denne patient i jeres hospitalsjournaler.",
    referenceDateLabel: "Dato, der tælles fra",
    referenceDateStartToday: "Start i dag",
    referenceDateAskPatient: "Patienten fortæller os det",
    inviteMethodLabel: "Sådan får patienten sin invitation",
    inviteMethodSend: "Send en e-mail eller sms",
    inviteMethodShare: "Vis en QR-kode eller kopiér et link",
    selectOrganisationToContinue: "Vælg en organisation for at fortsætte.",
    selectContactToContinue: "Vælg en kontaktperson for at fortsætte.",
    doctorEmailSharedWithPatient:
        "Denne e-mail deles med patienten, så vær forsigtig med at dele den eller bruge den her.",
    currentUserEmailSharedWithPatient:
        "Din e-mail deles med patienter og sættes cc på deres kommunikation. Vi anbefaler, at du tilføjer en generel hjælpe-e-mail, f.eks. afdelingens indbakke, som kontaktperson.",
    addContactPerson: "Tilføj person",
    personalContactEmailWarning: "Det ligner en personlig e-mail, og patienterne kan se den.",
    personalContactEmailAddContact: "Tilføj en generel kontakt",
    personalContactEmailAfterLink: "som info@clinic.com fra siden Team - det er gratis.",
    enterPhoneNumber: "Angiv telefonnummer",
    backToSetup: "Tilbage til opsætning",
    backToPatients: "Tilbage til patienter",
    patientInvite: "Patientinvitation",
    diaryQrCode: "Dagbog QR-kode",
    diaryQrDescription:
        "Del denne QR-kode eller link, så patienter kan tilmelde sig på deres telefon og starte denne dagbog. Opsætningsdetaljerne blev bekræftet på det foregående trin.",
    generatingInviteLink: "Opretter invitationslink…",
    failedToCreateInviteLink: "Invitationslink kunne ikke oprettes",
    hospitalOnTheInvite: "Hospital på invitationen",
    changingOrganisationUpdatesLink: "Ændring af dette opdaterer linket og QR-koden.",
    shownOnPatientSignupLink: "Vises på patientens tilmeldingslink.",
    patientWillChooseOrganisation: "Dette betyder, at patienten vælger deres organisation ved tilmelding.",
    hospitalNumber: "Hospitalsnummer",
    enterHospitalNumber: "Angiv hospitalsnummer",
    requiredForNhsOrganisations: "Vises for organisationer der indsamler hospitalsnummer",
    copyLink: "Kopiér link",
    copyQrCode: "Kopiér QR-kode",
    copyInviteLink: "Kopiér invitationslink",
    invitePageTitle: "Inviter",
    roleAndOrganisation: "Rolle og organisation",
    navInviteDescription: "Inviter en behandler, patient eller sekretær til Patient Watch.",
    tabEmail: "E-mail",
    tabQrCode: "QR-kode",
    optionalSuffix: "(valgfrit)",
};
